import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "./InfoAlert.css";

interface InfoAlertProps {
  children: ReactNode; // Flexible placement of text, links, etc.
}

const InfoAlert: React.FC<InfoAlertProps> = ({ children }) => {
  return (
    <Box className="info-alert-container">
      <InfoOutlinedIcon className="info-alert-icon" />
      <Box className="info-alert-content">{children}</Box>
    </Box>
  );
};

export default InfoAlert;